import React from "react";
import { Link } from "react-router-dom";
import season4Hero from "../Image2.png"; // Replace with your Season 4 hero image

function Season4Launch() {
  return (
    <div className="bg-zinc-900 text-white">
      {/* Hero Section */}
      <div
        className="h-[60vh] flex flex-col items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${season4Hero})`,
        }}
      >
        <h1 className="text-5xl font-bold mb-4">
          Season 4 Launch: New Adventures Await!
        </h1>
        <p className="text-xl">
          Join us as we embark on a new journey in Omnicraft SMP.
        </p>
      </div>

      {/* Launch Details Section */}
      <section className="py-12">
        <div className="max-w-5xl mx-auto px-4">
          <h2 className="text-3xl font-bold mb-4">Launch Details</h2>
          <p className="text-lg">
            Season 4 of Omnicraft SMP officially launches on{" "}
            <strong>June 1st</strong>. Get ready for an epic adventure filled
            with new challenges, mods, and community events!
          </p>
          <p className="mt-4">
            To join the launch, make sure you’ve applied and been accepted to
            the server. If you haven’t applied yet, click the button below to
            get started.
          </p>
          <Link
            to="/application"
            className="link mt-6 inline-block bg-blue-600 text-white px-6 py-3 rounded-full text-lg hover:bg-blue-700"
          >
            Apply Now
          </Link>
        </div>
      </section>

      {/* New Features Section */}
      <section className="py-12 bg-zinc-800">
        <div className="max-w-5xl mx-auto px-4">
          <h2 className="text-3xl font-bold mb-4">New Features in Season 4</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-zinc-700 p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold mb-2">New Structures</h3>
              <p>
                Explore brand new structures added to the world, offering unique
                resources and challenges.
              </p>
            </div>
            <div className="bg-zinc-700 p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold mb-2">Enhanced Gameplay</h3>
              <p>
                Experience improved mechanics and new mods that make survival
                more exciting than ever.
              </p>
            </div>
            <div className="bg-zinc-700 p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold mb-2">Exclusive Mods</h3>
              <p>
                Season 4 introduces exclusive mods curated specifically for
                Omnicraft SMP.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Community Spotlight Section */}
      <section className="py-12">
        <div className="max-w-5xl mx-auto px-4">
          <h2 className="text-3xl font-bold mb-4">Community Spotlight</h2>
          <p className="text-lg">
            Season 4 is all about community! Join us for special launch day
            events, including:
          </p>
          <ul className="list-disc list-inside mt-4">
            <li>A community build contest with amazing prizes.</li>
            <li>A group raid event to explore the new world together.</li>
            <li>Weekly challenges and activities to keep the fun going.</li>
          </ul>
          <p className="mt-4">
            Stay tuned to our Discord for event schedules and updates!
          </p>
        </div>
      </section>

      {/* FAQs Section */}
      <section className="py-12 bg-zinc-800">
        <div className="max-w-5xl mx-auto px-4">
          <h2 className="text-3xl font-bold mb-4">
            Frequently Asked Questions
          </h2>
          <div className="space-y-6">
            <div>
              <h3 className="text-xl font-semibold">
                What mods are included in Season 4?
              </h3>
              <p className="mt-2">
                Season 4 features a carefully selected modpack that can be
                viewed on curseforge{" "}
                <a
                  className="font-bold"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.curseforge.com/minecraft/modpacks/omnicraft-smp-s4"
                >
                  HERE
                </a>
                . These mods enhance gameplay while maintaining the core
                Minecraft experience.
              </p>
            </div>
            <div>
              <h3 className="text-xl font-semibold">
                How can I join the server for Season 4?
              </h3>
              <p className="mt-2">
                To join, you’ll need to apply through our application page. Once
                accepted, you’ll receive instructions on how to connect to the
                server.
              </p>
            </div>
            <div>
              <h3 className="text-xl font-semibold">
                Will my progress from previous seasons carry over?
              </h3>
              <p className="mt-2">
                No, Season 4 starts fresh with a new world and new challenges.
                However, your friendships and community ties will carry over!
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Join Us Section */}
      <section className="py-12">
        <div className="max-w-5xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-4">Ready to Join Season 4?</h2>
          <p className="mb-8 text-lg">
            Apply now and become part of the Omnicraft community!
          </p>
          <Link
            to="/application"
            className="link bg-blue-600 text-white px-6 py-3 rounded-full text-lg hover:bg-blue-700"
          >
            Apply Now
          </Link>
        </div>
      </section>
    </div>
  );
}

export default Season4Launch;
